import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SignalTranslationList from './SignalTranslationList';
import { getSignalTranslation, getUserProfileWidget, getCurrentTimezone, getUnitManager } from '../../selectors/index';
import { getSignalTranslationThunk, setCurrentPage, setPageFilter } from '../../actions/signalTranslation';

const mapStateToProps = state => {
  return {
    unitManager: getUnitManager(state),
    signalTranslationManager: getSignalTranslation(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSignalTranslation: (unitSerialNumber, filterObject) => getSignalTranslationThunk(unitSerialNumber, filterObject, 'UNIT_SIGNALTRANSLATION'),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SignalTranslationList);
